import { Button } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledChildButton = styled(Button)`
  && {
    :hover {
      background: ${({ theme }) => theme.colors.white};
    }
  }
`;
